import SummarySaleReportView from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleReport/SummarySaleReport'
import withSummarySaleReport from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleReport/withSummarySaleReport'

const SummarySaleReport = withSummarySaleReport(SummarySaleReportView)

export default SummarySaleReport
